import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { ParametersListAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getBatchParameters = createAsyncThunk<ParametersListAPI[], number>(
  `${Slices.BATCH_PARAMETERS}/get`,
  async (entity_id, { rejectWithValue }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get(`/batches/${entity_id}/parameters/list`);
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
